// File: /src/components/dashboard/StatusPieCard.js

import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';
import { FaChartPie } from 'react-icons/fa';

const CustomPieLegend = ({ payload }) => {
	if (!payload) return null;
	return (
		<ul className="custom-legend">
			{payload.map((entry) => (
				<li key={`legend-${entry.value}`}>
					<span
						style={{
							display: 'inline-block',
							width: '12px',
							height: '12px',
							backgroundColor: entry.color,
							borderRadius: '2px',
							marginRight: '8px',
						}}
					/>
					{entry.value}
				</li>
			))}
		</ul>
	);
};

const StatusPieCard = ({ pieData, pieColors, chartSize }) => (
	<div className="pie-card">
		<div className="card-icon">
			<FaChartPie size={16} />
		</div>
		<h2>Status dos Projetos</h2>
		<ResponsiveContainer width="100%" height={320}>
			<PieChart
				margin={{
					top: 20,
					right: 20,
					bottom: 20,
					left: 20,
				}}
			>
				<Pie
					data={pieData}
					dataKey="value"
					nameKey="name"
					cx="50%"
					cy="45%"
					innerRadius={chartSize.innerRadius}
					outerRadius={chartSize.outerRadius}
					paddingAngle={5}
					label={({
						cx,
						cy,
						midAngle,
						innerRadius,
						outerRadius,
						value,
						index,
					}) => {
						const RADIAN = Math.PI / 180;
						const radius =
							15 + innerRadius + (outerRadius - innerRadius);
						const x = cx + radius * Math.cos(-midAngle * RADIAN);
						const y = cy + radius * Math.sin(-midAngle * RADIAN);

						return (
							<text
								x={x}
								y={y}
								textAnchor={x > cx ? 'start' : 'end'}
								dominantBaseline="central"
								style={{
									fill: 'var(--chart-text, #0f172a)',
									fontSize: 8,
									fontFamily: 'Plus Jakarta Sans, sans-serif',
								}}
							>
								{pieData[index].name}: {value}
							</text>
						);
					}}
				>
					{pieData.map((entry, index) => (
						<Cell
							key={`cell-${entry.name}`}
							fill={pieColors[index % pieColors.length]}
						/>
					))}
				</Pie>
				<Legend
					content={<CustomPieLegend />}
					verticalAlign="bottom"
					align="center"
				/>
			</PieChart>
		</ResponsiveContainer>
	</div>
);

export default StatusPieCard;
